/** @format */

import { type App } from 'vue';

export const withInstall = <T>(component: T, alias?: string) => {
	const comp = component as any;
	comp.install = (app: App) => {
		app.component(comp.name || comp.displayName, comp);
		if (alias) {
			app.config.globalProperties[alias] = component;
		}
	};
	return component as T & Plugin;
};

/**
 * 根据 vue 文件地址路径 和 现有vue文件 获取 对应的vue组件 进行展示
 * @param { string } view views 目录内文件地址路径 eg: ` /** /** /*.vue `
 * @param vueModules 现有vue文件 const vueModules = import.meta.glob('./../../views/**\/*.vue');
 * @returns { undefined | Function }  对应的vue组件;
 **/
export function loadView(view: string, vueModules: any[]): undefined | Function {
	let res: undefined | Function = undefined;
	for (const path in vueModules) {
		const dir = path.split('views')[1].split('.vue')[0];
		if (dir === view) {
			res = () => vueModules[path]();
		}
	}
	return res;
}
